// import React, { useState, useEffect } from "react";
// import { generateCtAbdomenReport } from "../../utils/ctabdomen";
// import { API_BASE_URL } from "../Api/apiconnector";

// export default function CtAbdomenForm({ onSubmit, currentUser, onClose, onBack }) {
//   const initial = {
//     // Demographics
//     name: "",
//     patientId: "",
//     age: "",
//     testDate: "",
//     reportDate: "",
//     gender: "",
//     reportTime: "",
//     referralDoctor: "",

//     // Appendix Findings
//     appendix: false,
    
//     appendixDilated: false,
//     appendixDilatedText: "", // mm

//     periAppendicealFatStranding: false,
    
//     fluidCollection: false,
//     fluidTypeFree: false, 
//     fluidLocalized: false,
//     fluidLocalizedSize1: "",
//     fluidLocalizedSize2: "",

//     extraLuminalAirPockets: false,

//     mesentericNodes: false,
//     mesentericNodesType: "", // 'Few', 'Multiple', 'Subcentimetre size', 'Enlarged'
//     mesentericNodesEnlargedSize: "",

//     appendicularMass: false,
//     massWithAdhesion: false,
//     massSize1: "",
//     massSize2: ""
//   };

//   const [formData, setFormData] = useState(initial);

//   useEffect(() => {
//     const fetchDemographics = async () => {
//       try {
//         const urlParams = new URLSearchParams(window.location.search);
//         const patientId = urlParams.get("id");
//         if (!patientId) return;

//         const response = await fetch(`${API_BASE_URL}/fetch-dicom/`, {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//             Authorization: `Bearer ${localStorage.getItem("token")}`,
//           },
//           body: JSON.stringify({ id: patientId }),
//         });

//         if (!response.ok) throw new Error(`Failed to fetch demographics (${response.status})`);
//         const data = await response.json();
//         console.log("✅ Fetched demographics:", data);

//         const formattedStudyDate = data.study_date || "";
//         const now = new Date();
//         const formattedReportDate = formatToDDMMYYYY(now);
//         const formattedReportTime = now.toLocaleTimeString("en-GB");

//         setFormData((prev) => ({
//           ...prev,
//           name: data.patient_name || "",
//           patientId: data.patient_id || "",
//           age: data.age || "",
//           gender: data.gender || "",
//           referralDoctor: data.referring_doctor_name || "",
//           testDate: formattedStudyDate,
//           reportDate: formattedReportDate,
//           reportTime: formattedReportTime,
//         }));
//       } catch (error) {
//         console.error("❌ Error fetching DICOM demographics:", error);
//       }
//     };

//     fetchDemographics();
//   }, []);

//   // ✅ Helpers
//   function formatToDDMMYYYY(date) {
//     const day = String(date.getDate()).padStart(2, "0");
//     const month = String(date.getMonth() + 1).padStart(2, "0");
//     const year = date.getFullYear();
//     return `${day}-${month}-${year}`;
//   }

//   function formatToISODate(ddmmyyyy) {
//     if (!ddmmyyyy) return "";
//     const [day, month, year] = ddmmyyyy.split("-");
//     return `${year}-${month}-${day}`;
//   }

//   function formatToDDMMYYYYFromISO(isoDate) {
//     if (!isoDate) return "";
//     const [year, month, day] = isoDate.split("-");
//     return `${day}-${month}-${year}`;
//   }

//   const setField = (path, value) => {
//     if (!path.includes(".")) {
//       setFormData((prev) => ({ ...prev, [path]: value }));
//       return;
//     }
//     const parts = path.split(".");
//     setFormData((prev) => {
//       const copy = { ...prev };
//       let cur = copy;
//       for (let i = 0; i < parts.length - 1; i++) {
//         cur[parts[i]] = { ...cur[parts[i]] };
//         cur = cur[parts[i]];
//       }
//       cur[parts[parts.length - 1]] = value;
//       return copy;
//     });
//   };

//   const transformFormDataForReport = (data) => {
//     return {
//       // Mapping to match exactly what logic file expects
//       NameTextFR18: data.name,
//       IDTextFR18: data.patientId,
//       AgeTextFR18: data.age,
//       GenderTextFR18: data.gender,
//       TestDateTextFR18: data.testDate,
//       ReportDateTextFR18: data.reportDate,
//       ReferralDrTextFR18: data.referralDoctor,
//       ReporttimeTextFR18: data.reportTime,

//       Appendix: data.appendix,
//       AppendixDialated: data.appendixDilated,
//       AppendixDialatedText: data.appendixDilatedText,
//       AppendixDialatedPeriappendicealFatStranding: data.periAppendicealFatStranding,
      
//       AppendixDialatedPeriappendicealFluidCollection: data.fluidCollection,
//       AppendixDialatedPeriappendicealFluidType: data.fluidTypeFree,
//       AppendixDialatedPeriappendicealPeriphereally: data.fluidLocalized,
//       AppendixDialatedPeriappendicealPeriphereallyText: data.fluidLocalizedSize1,
//       AppendixDialatedPeriappendicealPeriphereallyText1: data.fluidLocalizedSize2,
      
//       AppendixDialatedPeriappendiceal: data.extraLuminalAirPockets,
      
//       AppendixDialatedMesentericNodes: data.mesentericNodes,
//       AppendixDialatedMesentericNodesType: data.mesentericNodesType,
//       AppendixDialatedMesentericNodesEnlarged: data.mesentericNodesEnlargedSize,
      
//       AppendixDialatedAppendicularMass: data.appendicularMass,
//       AppendixDialatedAppendicularMassWithAdhesion: data.massWithAdhesion,
//       AppendixDialatedAppendicularMassWithAdhesionText: data.massSize1,
//       AppendixDialatedAppendicularMassWithAdhesionText1: data.massSize2,
//     };
//   };

//   const handleDone = (e) => {
//     e.preventDefault();
//     const flatFormData = transformFormDataForReport(formData);
//     const reportHtml = generateCtAbdomenReport(flatFormData, currentUser);

//     if (window.editor) {
//       const existingData = window.editor.getData();
//       const updatedData = `${existingData}<br/><hr/><br/>${reportHtml}`;
//       window.editor.setData(updatedData);
//     }

//     if (onSubmit) onSubmit(reportHtml);
//     if (onClose) onClose();
//   };

//   return (
//     <form onSubmit={handleDone} className="p-4 space-y-4 border rounded shadow-md max-w-4xl mx-auto">
//       <h2 className="text-xl font-bold">CT ABDOMEN</h2>
      
//       <div className="flex gap-2">
//         <button type="submit" className="bg-blue-500 text-white px-4 py-1 rounded hover:bg-blue-600 transition">
//           Done
//         </button>
//         <button
//           type="button"
//           onClick={() => {
//             if (onBack) onBack(); 
//             if (onClose) onClose();
//           }}
//           className="bg-gray-500 text-white px-4 py-1 rounded hover:bg-gray-600 transition"
//         >
//           Back
//         </button>
//       </div>

//       <div className="grid grid-cols-2 gap-4">
//         <input className="border p-2 rounded" placeholder="Name" value={formData.name}
//                onChange={e => setField('name', e.target.value)} />
//         <input className="border p-2 rounded" placeholder="Patient ID" value={formData.patientId}
//                onChange={e => setField('patientId', e.target.value)} />
//         <input className="border p-2 rounded" placeholder="Age" type="number" value={formData.age}
//                onChange={e => setField('age', e.target.value)} />
//         <input className="border p-2 rounded" type="date" value={formData.testDate}
//                onChange={e => setField('testDate', e.target.value)} title="Test Date"/>
//         <input className="border p-2 rounded" type="date" value={formatToISODate(formData.reportDate)}
//                onChange={e => setField('reportDate', formatToDDMMYYYYFromISO(e.target.value))} 
//                title="Report Date" />
        
//         <div>
//           <label className="font-semibold block mb-1">Gender</label>
//           <div className="flex gap-3">
//             {["Male","Female","Others"].map(g => (
//               <label key={g} className="flex items-center gap-1 cursor-pointer">
//                 <input type="radio" name="gender" checked={formData.gender === g}
//                        onChange={() => setField('gender', g)} /> {g}
//               </label>
//             ))}
//           </div>
//         </div>
//       </div>

//       <hr className="my-4" />

//       {/* Main Appendix Trigger */}
//       <div className="space-y-4">
//         <label className="flex items-center gap-2 font-bold text-lg cursor-pointer">
//           <input type="checkbox" className="w-5 h-5" checked={formData.appendix} 
//                  onChange={() => setField('appendix', !formData.appendix)} />
//           Appendix Findings
//         </label>

//         {formData.appendix && (
//           <div className="border p-4 rounded bg-gray-50 space-y-4">
            
//             {/* Dilated */}
//             <div className="flex flex-col gap-2">
//               <label className="flex items-center gap-2 font-semibold cursor-pointer">
//                 <input type="checkbox" checked={formData.appendixDilated} 
//                        onChange={() => setField('appendixDilated', !formData.appendixDilated)} /> 
//                 Appendix Dilated?
//               </label>
//               {formData.appendixDilated && (
//                 <div className="ml-6 flex items-center gap-2">
//                   <span className="text-sm">Measurement (mm):</span>
//                   <input className="border p-1 rounded w-24" type="number" value={formData.appendixDilatedText}
//                          onChange={e => setField('appendixDilatedText', e.target.value)} placeholder="e.g. 8" />
//                 </div>
//               )}
//             </div>

//             {/* Fat Stranding */}
//             <label className="flex items-center gap-2 font-semibold cursor-pointer">
//               <input type="checkbox" checked={formData.periAppendicealFatStranding} 
//                      onChange={() => setField('periAppendicealFatStranding', !formData.periAppendicealFatStranding)} /> 
//               Peri-appendiceal fat stranding
//             </label>

//             {/* Fluid Collection */}
//             <div className="flex flex-col gap-2">
//               <label className="flex items-center gap-2 font-semibold cursor-pointer">
//                 <input type="checkbox" checked={formData.fluidCollection} 
//                        onChange={() => setField('fluidCollection', !formData.fluidCollection)} /> 
//                 Peri-appendiceal fluid collection
//               </label>

//               {formData.fluidCollection && (
//                 <div className="ml-6 space-y-3 p-3 border rounded bg-white">
//                   <label className="flex items-center gap-2 cursor-pointer">
//                     <input type="checkbox" checked={formData.fluidTypeFree} 
//                            onChange={() => setField('fluidTypeFree', !formData.fluidTypeFree)} /> 
//                     Free Fluid
//                   </label>
                  
//                   <label className="flex items-center gap-2 cursor-pointer">
//                     <input type="checkbox" checked={formData.fluidLocalized} 
//                            onChange={() => setField('fluidLocalized', !formData.fluidLocalized)} /> 
//                     Peripherally enhancing localized fluid collection (Abscess)
//                   </label>
                  
//                   {formData.fluidLocalized && (
//                     <div className="ml-6 flex items-center gap-2">
//                       <input className="border p-1 rounded w-20" type="number" placeholder="cm"
//                              value={formData.fluidLocalizedSize1} onChange={e => setField('fluidLocalizedSize1', e.target.value)} />
//                       <span>x</span>
//                       <input className="border p-1 rounded w-20" type="number" placeholder="cm"
//                              value={formData.fluidLocalizedSize2} onChange={e => setField('fluidLocalizedSize2', e.target.value)} />
//                     </div>
//                   )}
//                 </div>
//               )}
//             </div>

//             {/* Extra Luminal Air Pockets */}
//             <label className="flex items-center gap-2 font-semibold cursor-pointer">
//               <input type="checkbox" checked={formData.extraLuminalAirPockets} 
//                      onChange={() => setField('extraLuminalAirPockets', !formData.extraLuminalAirPockets)} /> 
//               Peri-appendiceal extra luminal air pockets (Perforation)
//             </label>

//             {/* Mesenteric Nodes */}
//             <div className="flex flex-col gap-2">
//               <label className="flex items-center gap-2 font-semibold cursor-pointer">
//                 <input type="checkbox" checked={formData.mesentericNodes} 
//                        onChange={() => setField('mesentericNodes', !formData.mesentericNodes)} /> 
//                 Mesenteric nodes
//               </label>

//               {formData.mesentericNodes && (
//                 <div className="ml-6 p-3 border rounded bg-white space-y-2">
//                   <div className="flex flex-wrap gap-4">
//                     {['Few', 'Multiple', 'Subcentimetre size', 'Enlarged'].map(type => (
//                       <label key={type} className="flex items-center gap-1 cursor-pointer">
//                         <input type="radio" name="nodesType" checked={formData.mesentericNodesType === type}
//                                onChange={() => setField('mesentericNodesType', type)} /> {type}
//                       </label>
//                     ))}
//                   </div>
//                   {formData.mesentericNodesType === 'Enlarged' && (
//                     <div className="mt-2 flex items-center gap-2">
//                       <span className="text-sm">Largest Node Size (mm):</span>
//                       <input className="border p-1 rounded w-24" type="number" value={formData.mesentericNodesEnlargedSize}
//                              onChange={e => setField('mesentericNodesEnlargedSize', e.target.value)} />
//                     </div>
//                   )}
//                 </div>
//               )}
//             </div>

//             {/* Appendicular Mass */}
//             <div className="flex flex-col gap-2">
//               <label className="flex items-center gap-2 font-semibold cursor-pointer">
//                 <input type="checkbox" checked={formData.appendicularMass} 
//                        onChange={() => setField('appendicularMass', !formData.appendicularMass)} /> 
//                 Appendicular mass formation
//               </label>
              
//               {formData.appendicularMass && (
//                 <div className="ml-6 p-3 border rounded bg-white space-y-2">
//                   <label className="flex items-center gap-2 cursor-pointer">
//                     <input type="checkbox" checked={formData.massWithAdhesion} 
//                            onChange={() => setField('massWithAdhesion', !formData.massWithAdhesion)} /> 
//                     With adhesion to distal ileal loops and caecum
//                   </label>
                  
//                   {formData.massWithAdhesion && (
//                     <div className="ml-6 flex items-center gap-2 mt-2">
//                       <span className="text-sm">Measurements (cm):</span>
//                       <input className="border p-1 rounded w-20" type="number" placeholder="X"
//                              value={formData.massSize1} onChange={e => setField('massSize1', e.target.value)} />
//                       <span>x</span>
//                       <input className="border p-1 rounded w-20" type="number" placeholder="Y"
//                              value={formData.massSize2} onChange={e => setField('massSize2', e.target.value)} />
//                     </div>
//                   )}
//                 </div>
//               )}
//             </div>

//           </div>
//         )}
//       </div>

//     </form>
//   );
// }



import React, { useState, useEffect } from "react";
import { generateCtAbdomenReport } from "../../utils/ctabdomen";
import { API_BASE_URL } from "../Api/apiconnector";

export default function CtAbdomenForm({ generateReport, currentUser, onClose, onBack }) {
  const initial = {
    name: "", patientId: "", age: "", testDate: "", reportDate: "", gender: "", reportTime: "", referralDoctor: "",
    appendix: false,
    appendixDilated: false,
    appendixDilatedText: "",
    periAppendicealFatStranding: false,
    fluidCollection: false,
    fluidTypeFree: false, 
    fluidLocalized: false,
    fluidLocalizedSize1: "",
    fluidLocalizedSize2: "",
    extraLuminalAirPockets: false,
    mesentericNodes: false,
    mesentericNodesType: "",
    mesentericNodesEnlargedSize: "",
    appendicularMass: false,
    massWithAdhesion: false,
    massSize1: "",
    massSize2: ""
  };

  const [formData, setFormData] = useState(initial);

  useEffect(() => {
    const fetchDemographics = async () => {
      try {
        const urlParams = new URLSearchParams(window.location.search);
        const patientId = urlParams.get("id");
        if (!patientId) return;

        const response = await fetch(`${API_BASE_URL}/fetch-dicom/`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${localStorage.getItem("token")}`,
          },
          body: JSON.stringify({ id: patientId }),
        });

        if (!response.ok) throw new Error(`Failed to fetch demographics (${response.status})`);
        const data = await response.json();

        const formattedStudyDate = data.study_date || "";
        const now = new Date();
        const formattedReportDate = formatToDDMMYYYY(now);
        const formattedReportTime = now.toLocaleTimeString("en-GB");

        setFormData((prev) => ({
          ...prev,
          name: data.patient_name || "",
          patientId: data.patient_id || "",
          age: data.age || "",
          gender: data.gender || "",
          referralDoctor: data.referring_doctor_name || "",
          testDate: formattedStudyDate,
          reportDate: formattedReportDate,
          reportTime: formattedReportTime,
        }));
      } catch (error) {
        console.error("❌ Error fetching DICOM demographics:", error);
      }
    };
    fetchDemographics();
  }, []);

  function formatToDDMMYYYY(date) {
    return `${String(date.getDate()).padStart(2, "0")}-${String(date.getMonth() + 1).padStart(2, "0")}-${date.getFullYear()}`;
  }

  function formatToISODate(ddmmyyyy) {
    if (!ddmmyyyy) return "";
    const [day, month, year] = ddmmyyyy.split("-");
    return `${year}-${month}-${day}`;
  }

  function formatToDDMMYYYYFromISO(isoDate) {
    if (!isoDate) return "";
    const [year, month, day] = isoDate.split("-");
    return `${day}-${month}-${year}`;
  }

  const setField = (path, value) => {
    setFormData((prev) => ({ ...prev, [path]: value }));
  };

  const transformFormDataForReport = (data) => {
    return {
      NameTextFR18: data.name,
      IDTextFR18: data.patientId,
      AgeTextFR18: data.age,
      GenderTextFR18: data.gender,
      TestDateTextFR18: data.testDate,
      ReportDateTextFR18: data.reportDate,
      ReferralDrTextFR18: data.referralDoctor,
      ReporttimeTextFR18: data.reportTime,
      Appendix: data.appendix,
      AppendixDialated: data.appendixDilated,
      AppendixDialatedText: data.appendixDilatedText,
      AppendixDialatedPeriappendicealFatStranding: data.periAppendicealFatStranding,
      AppendixDialatedPeriappendicealFluidCollection: data.fluidCollection,
      AppendixDialatedPeriappendicealFluidType: data.fluidTypeFree,
      AppendixDialatedPeriappendicealPeriphereally: data.fluidLocalized,
      AppendixDialatedPeriappendicealPeriphereallyText: data.fluidLocalizedSize1,
      AppendixDialatedPeriappendicealPeriphereallyText1: data.fluidLocalizedSize2,
      AppendixDialatedPeriappendiceal: data.extraLuminalAirPockets,
      AppendixDialatedMesentericNodes: data.mesentericNodes,
      AppendixDialatedMesentericNodesType: data.mesentericNodesType,
      AppendixDialatedMesentericNodesEnlarged: data.mesentericNodesEnlargedSize,
      AppendixDialatedAppendicularMass: data.appendicularMass,
      AppendixDialatedAppendicularMassWithAdhesion: data.massWithAdhesion,
      AppendixDialatedAppendicularMassWithAdhesionText: data.massSize1,
      AppendixDialatedAppendicularMassWithAdhesionText1: data.massSize2,
    };
  };

  const handleDone = (e) => {
    e.preventDefault();
    const flatFormData = transformFormDataForReport(formData);
    const reportHtml = generateCtAbdomenReport(flatFormData, currentUser);

    if (generateReport) generateReport(reportHtml);
    if (onClose) onClose();
  };

  return (
    <form onSubmit={handleDone} className="p-4 space-y-4 border rounded shadow-md max-w-4xl mx-auto bg-white">
      <h2 className="text-xl font-bold">CT ABDOMEN</h2>
      
      <div className="flex gap-2">
        <button type="submit" className="bg-blue-500 text-white px-4 py-1 rounded hover:bg-blue-600 transition">
          Done
        </button>
        <button
          type="button"
          onClick={() => {
            if (onBack) onBack(); 
            if (onClose) onClose();
          }}
          className="bg-gray-500 text-white px-4 py-1 rounded hover:bg-gray-600 transition"
        >
          Back
        </button>
      </div>

      <div className="grid grid-cols-2 gap-4">
        <input className="border p-2 rounded" placeholder="Name" value={formData.name} onChange={e => setField('name', e.target.value)} />
        <input className="border p-2 rounded" placeholder="Patient ID" value={formData.patientId} onChange={e => setField('patientId', e.target.value)} />
        <input className="border p-2 rounded" placeholder="Age" type="number" value={formData.age} onChange={e => setField('age', e.target.value)} />
        <input className="border p-2 rounded" type="date" value={formData.testDate} onChange={e => setField('testDate', e.target.value)} title="Test Date"/>
        <input className="border p-2 rounded" type="date" value={formatToISODate(formData.reportDate)} onChange={e => setField('reportDate', formatToDDMMYYYYFromISO(e.target.value))} title="Report Date" />
        
        <div>
          <label className="font-semibold block mb-1">Gender</label>
          <div className="flex gap-3">
            {["Male","Female","Others"].map(g => (
              <label key={g} className="flex items-center gap-1 cursor-pointer">
                <input type="radio" name="gender" checked={formData.gender === g} onChange={() => setField('gender', g)} /> {g}
              </label>
            ))}
          </div>
        </div>
      </div>

      <hr className="my-4" />

      {/* Main Appendix Trigger */}
      <div className="space-y-4">
        <label className="flex items-center gap-2 font-bold text-lg cursor-pointer">
          <input type="checkbox" className="w-5 h-5" checked={formData.appendix} onChange={() => setField('appendix', !formData.appendix)} />
          Appendix Findings
        </label>

        {formData.appendix && (
          <div className="border p-4 rounded bg-gray-50 space-y-4">
            
            {/* Dilated */}
            <div className="flex flex-col gap-2">
              <label className="flex items-center gap-2 font-semibold cursor-pointer">
                <input type="checkbox" checked={formData.appendixDilated} onChange={() => setField('appendixDilated', !formData.appendixDilated)} /> Appendix Dilated?
              </label>
              {formData.appendixDilated && (
                <div className="ml-6 flex items-center gap-2">
                  <span className="text-sm">Measurement (mm):</span>
                  <input className="border p-1 rounded w-24" type="number" value={formData.appendixDilatedText} onChange={e => setField('appendixDilatedText', e.target.value)} placeholder="e.g. 8" />
                </div>
              )}
            </div>

            <label className="flex items-center gap-2 font-semibold cursor-pointer">
              <input type="checkbox" checked={formData.periAppendicealFatStranding} onChange={() => setField('periAppendicealFatStranding', !formData.periAppendicealFatStranding)} /> Peri-appendiceal fat stranding
            </label>

            <div className="flex flex-col gap-2">
              <label className="flex items-center gap-2 font-semibold cursor-pointer">
                <input type="checkbox" checked={formData.fluidCollection} onChange={() => setField('fluidCollection', !formData.fluidCollection)} /> Peri-appendiceal fluid collection
              </label>
              {formData.fluidCollection && (
                <div className="ml-6 space-y-3 p-3 border rounded bg-white">
                  <label className="flex items-center gap-2 cursor-pointer">
                    <input type="checkbox" checked={formData.fluidTypeFree} onChange={() => setField('fluidTypeFree', !formData.fluidTypeFree)} /> Free Fluid
                  </label>
                  <label className="flex items-center gap-2 cursor-pointer">
                    <input type="checkbox" checked={formData.fluidLocalized} onChange={() => setField('fluidLocalized', !formData.fluidLocalized)} /> Peripherally enhancing localized fluid collection (Abscess)
                  </label>
                  {formData.fluidLocalized && (
                    <div className="ml-6 flex items-center gap-2">
                      <input className="border p-1 rounded w-20" type="number" placeholder="cm" value={formData.fluidLocalizedSize1} onChange={e => setField('fluidLocalizedSize1', e.target.value)} />
                      <span>x</span>
                      <input className="border p-1 rounded w-20" type="number" placeholder="cm" value={formData.fluidLocalizedSize2} onChange={e => setField('fluidLocalizedSize2', e.target.value)} />
                    </div>
                  )}
                </div>
              )}
            </div>

            <label className="flex items-center gap-2 font-semibold cursor-pointer">
              <input type="checkbox" checked={formData.extraLuminalAirPockets} onChange={() => setField('extraLuminalAirPockets', !formData.extraLuminalAirPockets)} /> Peri-appendiceal extra luminal air pockets (Perforation)
            </label>

            <div className="flex flex-col gap-2">
              <label className="flex items-center gap-2 font-semibold cursor-pointer">
                <input type="checkbox" checked={formData.mesentericNodes} onChange={() => setField('mesentericNodes', !formData.mesentericNodes)} /> Mesenteric nodes
              </label>
              {formData.mesentericNodes && (
                <div className="ml-6 p-3 border rounded bg-white space-y-2">
                  <div className="flex flex-wrap gap-4">
                    {['Few', 'Multiple', 'Subcentimetre size', 'Enlarged'].map(type => (
                      <label key={type} className="flex items-center gap-1 cursor-pointer">
                        <input type="radio" name="nodesType" checked={formData.mesentericNodesType === type} onChange={() => setField('mesentericNodesType', type)} /> {type}
                      </label>
                    ))}
                  </div>
                  {formData.mesentericNodesType === 'Enlarged' && (
                    <div className="mt-2 flex items-center gap-2">
                      <span className="text-sm">Largest Node Size (mm):</span>
                      <input className="border p-1 rounded w-24" type="number" value={formData.mesentericNodesEnlargedSize} onChange={e => setField('mesentericNodesEnlargedSize', e.target.value)} />
                    </div>
                  )}
                </div>
              )}
            </div>

            <div className="flex flex-col gap-2">
              <label className="flex items-center gap-2 font-semibold cursor-pointer">
                <input type="checkbox" checked={formData.appendicularMass} onChange={() => setField('appendicularMass', !formData.appendicularMass)} /> Appendicular mass formation
              </label>
              {formData.appendicularMass && (
                <div className="ml-6 p-3 border rounded bg-white space-y-2">
                  <label className="flex items-center gap-2 cursor-pointer">
                    <input type="checkbox" checked={formData.massWithAdhesion} onChange={() => setField('massWithAdhesion', !formData.massWithAdhesion)} /> With adhesion to distal ileal loops and caecum
                  </label>
                  {formData.massWithAdhesion && (
                    <div className="ml-6 flex items-center gap-2 mt-2">
                      <span className="text-sm">Measurements (cm):</span>
                      <input className="border p-1 rounded w-20" type="number" placeholder="X" value={formData.massSize1} onChange={e => setField('massSize1', e.target.value)} />
                      <span>x</span>
                      <input className="border p-1 rounded w-20" type="number" placeholder="Y" value={formData.massSize2} onChange={e => setField('massSize2', e.target.value)} />
                    </div>
                  )}
                </div>
              )}
            </div>

          </div>
        )}
      </div>
    </form>
  );
}